export default [
  {
    name: 'Good',
    value: 'good',
    toggleUpgrades: false,
    toggleSearchAdvertising: false,
    togglePremiumSEO: false,
    toggleBlogSocial: false,
    selectedUpgrade: null,
    selectedSearchAdvertising: null,
    selectedPremiumSEO: null,
    selectedBlogSocial: null
  },
  {
    name: 'Better',
    value: 'better',
    toggleUpgrades: true,
    toggleSearchAdvertising: false,
    togglePremiumSEO: false,
    toggleBlogSocial: true,
    selectedUpgrade: 0,
    selectedSearchAdvertising: null,
    selectedPremiumSEO: null,
    selectedBlogSocial: 0
  },
  {
    name: 'Best',
    value: 'best',
    toggleUpgrades: true,
    toggleSearchAdvertising: false,
    togglePremiumSEO: true,
    toggleBlogSocial: true,
    selectedUpgrade: 1,
    selectedSearchAdvertising: null,
    selectedPremiumSEO: 0,
    selectedBlogSocial: 2
  }
]



// WEBPACK FOOTER //
// ./src/data/packages.js